import WOW from 'wowjs';
(new WOW.WOW).init();